import { render, staticRenderFns } from "./PaginationServer.vue?vue&type=template&id=60faaa54&"
import script from "./PaginationServer.vue?vue&type=script&lang=js&"
export * from "./PaginationServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports